import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DoctorsHero from '../components/doctors/DoctorsHero';
import DoctorModal from '../components/doctors/DoctorModal';
import AppointmentForm from '../components/doctors/AppointmentForm';
import DoctorsFilter from '../components/doctors/DoctorsFilter';
import DoctorsList from '../components/doctors/DoctorsList';

const Doctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    genders: ['Male', 'Female'],
    specialties: [],
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  });
  const [loading, setLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [appointmentDoctor, setAppointmentDoctor] = useState(null);
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);
  const [filters, setFilters] = useState({
    gender: '',
    specialty: [],
    days: []
  });
  const [searchTerm, setSearchTerm] = useState('');
  const apiUrl = import.meta.env.VITE_API_URL

  useEffect(() => {
    fetchSpecializations(); // Call this instead of fetchFilterOptions
    fetchDoctors();
  }, []);



  useEffect(() => {
    const timer = setTimeout(() => {
      fetchDoctors();
    }, 300); // Add slight debounce for search term changes
    
    return () => clearTimeout(timer);
  }, [filters, searchTerm]); 

  const fetchFilterOptions = async () => {
    try {
      const response = await axios.get(`${apiUrl}/doctor-filter-options/`);
      setFilterOptions({
        genders: response.data.genders,
        days: response.data.days,
        specialties: response.data.specialties.map(spec => ({
          id: spec.id,
          name: spec.name
        }))
      });
    } catch (error) {
      console.error('Failed to fetch filter options:', error);
    }
  };

  const fetchSpecializations = async () => {
    try {
      const response = await axios.get(`${apiUrl}/specializations/`);
      setFilterOptions(prev => ({
        ...prev,
        specialties: response.data.map(spec => ({
          id: spec.id,
          name: spec.name
        }))
      }));
    } catch (error) {
      console.error('Failed to fetch specializations:', error);
    }
  };

  const fetchDoctors = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      
      // Gender filter
      if (filters.gender) {
        params.append('gender', filters.gender);
        console.log('Applying gender filter:', filters.gender);
      }
      
      // Specialty filter
      if (filters.specialty.length > 0) {
        filters.specialty.forEach(id => {
          params.append('specialty', id);
          console.log('Adding specialty filter:', id);
        });
      }
      
      // Availability filter
      if (filters.days.length > 0) {
        params.append('availability', filters.days.join(','));
        console.log('Applying availability filter:', filters.days);
      }
      
      // Search term
      if (searchTerm) {
        params.append('search', searchTerm);
        console.log('Applying search term:', searchTerm);
      }
  
      console.log('Final API request params:', params.toString());
      const response = await axios.get(`${apiUrl}/doctors/`, { params });
      console.log('Received doctors:', response.data);
      setDoctors(response.data);
    } catch (error) {
      console.error('Failed to fetch doctors:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleBookNow = (doctor) => {
    setAppointmentDoctor(doctor);
    setShowAppointmentForm(true);
  };

  // const handleAppointmentSubmit = async (formData) => {
  //   try {
  //     const appointmentData = {
  //       doctor: appointmentDoctor.id,
  //       patient_name: formData.name,
  //       patient_email: formData.email,
  //       patient_phone: formData.phone,
  //       appointment_date: formData.date,
  //       appointment_time: formData.time,
  //       reason: formData.reason
  //     };

  //     await axios.post(`${apiUrl}/appointments/`, appointmentData);
  //     setShowAppointmentForm(false);
  //     // Show success message
  //     return true;
  //   } catch (error) {
  //     console.error('Failed to book appointment:', error);
  //     return false;
  //   }
  // };

  return (
    <div className="doctors-page">
      <DoctorsHero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
           <DoctorsFilter
              filters={filters}
              setFilters={setFilters}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              filterOptions={filterOptions}
              // onApplyFilters={fetchDoctors}
            />
          </div>
          <div className="lg:col-span-3">
            <DoctorsList
              doctors={doctors}
              loading={loading}
              setSelectedDoctor={setSelectedDoctor}
              onBookNow={handleBookNow}
            />
          </div>
        </div>
      </div>

      {selectedDoctor && (
        <DoctorModal
          doctor={selectedDoctor}
          onClose={() => setSelectedDoctor(null)}
          onBookAppointment={() => {
            setAppointmentDoctor(selectedDoctor);
            setSelectedDoctor(null);
            setShowAppointmentForm(true);
          }}
        />
      )}

      {showAppointmentForm && (
        <AppointmentForm 
          doctor={appointmentDoctor}
          onClose={() => setShowAppointmentForm(false)}
        />
      )}
    </div>
  );
};

export default Doctors;